const UNEDITABLE_STATUSES = [
  'delivered',
  'shipped',
  'unscheduled',
  'packaged',
  'failed',
  'awaiting_packing',
  'redo',
  'returned',
];

export default function shipmentIsEditable(status: string | null | undefined): boolean {
  return !UNEDITABLE_STATUSES.includes(status ?? '');
}
